import { render, staticRenderFns } from "./plane.vue?vue&type=template&id=211a5a28&scoped=true"
import script from "./plane.vue?vue&type=script&lang=js"
export * from "./plane.vue?vue&type=script&lang=js"
import style0 from "./plane.vue?vue&type=style&index=0&id=211a5a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a5a28",
  null
  
)

export default component.exports